import React from 'react'
import styled from 'styled-components'
import Button from '@jarvis.oddle/core/components/Button'

const baseAnimationTime = '200ms'

const Base = styled.span`
  display: block;
  transition-property: opacity, transform;
  transition-duration: ${baseAnimationTime};
`

const First = styled(Base)`
  transition-delay: ${baseAnimationTime};
`

const Second = styled(Base)`
  position: absolute;
  top: 0;
  left: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition-delay: 0ms;
`

const Container = styled.span`
  display: block;
  position: relative;
`

const StyledButton = styled(Button)`
  overflow: hidden;
  &:hover {
    ${First} {
      opacity: 0;
      transform: translate(-100%, 0);
      transition-delay: 0ms;
    }
    ${Second} {
      opacity: 1;
      transform: translate(-100%, 0);
      transition-delay: ${baseAnimationTime};
    }
  }
`

interface SlideButtonProps {
  children: JSX.Element
  onClick: () => void
  width: string
  disabled: boolean
}

const SlideButton = ({ children, ...props }: SlideButtonProps): JSX.Element => {
  return (
    <StyledButton id='slideButton' {...props}>
      {Array.isArray(children) ? (
        <Container>
          <First>{children[0]}</First>
          <Second>{children[1]}</Second>
        </Container>
      ) : (
        children
      )}
    </StyledButton>
  )
}

export default SlideButton
